import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { heroData } from '../data/mock';

const Hero = () => {
  const highlightPhrase = 'Styled for Luxury';
  const cleanTitle = heroData.title.replace(',', '');
  const headlinePrimary = cleanTitle.replace(` ${highlightPhrase}`, '');
  const headlineSecondary = cleanTitle.includes(highlightPhrase) ? highlightPhrase : '';

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        >
          <source 
            src="/design_video (1).mp4" 
            type="video/mp4" 
          />
        </video>
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center px-6 max-w-5xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="inline-block mb-7 px-5 py-2 border border-[#e8d5c4]/60 bg-black/30 tracking-[0.2em] uppercase text-[10px] md:text-xs text-[#e8d5c4]"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Interior Design Studio
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="mx-auto max-w-6xl text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[8.5rem] font-semibold text-white mb-9 leading-[1.02] tracking-[0.01em] drop-shadow-[0_10px_40px_rgba(0,0,0,0.7)]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            <span className="block mb-2 sm:mb-3">{headlinePrimary}</span>
            {headlineSecondary && (
              <span className="block text-[#e8d5c4] italic">{headlineSecondary}</span>
            )}
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
            className="text-xl md:text-[1.8rem] lg:text-[2rem] text-[#e8d5c4] mb-5 tracking-[0.02em]"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            {heroData.subtitle}
          </motion.p>
          
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.6 }}
            className="mx-auto max-w-2xl text-[1.05rem] md:text-[1.2rem] text-white/85 mb-12 leading-relaxed"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            {heroData.description}
          </motion.p>
          
          <motion.button
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.8 }}
            whileHover={{ scale: 1.05, boxShadow: '0 0 30px rgba(232, 213, 196, 0.5)' }}
            whileTap={{ scale: 0.95 }}
            onClick={scrollToContact}
            aria-label="Book appointment — scroll to contact section"
            className="px-10 py-4 bg-[#e8d5c4] text-black font-semibold tracking-wide uppercase transition-all"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            {heroData.cta}
          </motion.button>
        </div>
      </div>
      
    </section>
  );
};

export default Hero;
